import script from "./Registering.vue?vue&type=script&lang=ts&setup=true"
export * from "./Registering.vue?vue&type=script&lang=ts&setup=true"

import "./Registering.vue?vue&type=style&index=0&id=48b28dcc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b28dcc"]])

export default __exports__